import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/Cancel';
import "./style.scss";

const DialogComponent = (props) => {
  const { handleClose, open, title, content } = props;

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
      maxWidth="sm"
      className="dialogBox p-1"
    >
      {handleClose ? (
          <CancelIcon onClick={handleClose} className="close-icon" />
      ) : null}
      {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
    </Dialog>
  );
}

DialogComponent.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default DialogComponent;